import React, { Component } from 'react';
import { string, objectOf } from 'prop-types';

import Error from '@material-ui/icons/Error';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import styles from './styles.scss';

export const adKeyword = 'adBanner';
export class AdBlockDetector extends Component {
  static propTypes = {
    title: string,
    message: string,
    instructions: string,
    buttonLabel: string,
    classes: objectOf(string),
  }

  static defaultProps = {
    title: 'Ad Blocker Detected',
    message: `We've detected the use of an Ad Blocker browser add-on which prevents the display of charts and dashboards for this application.`,
    instructions: 'Please disable the browser add-on and refresh this page.',
    buttonLabel: 'OK',
    classes: {}
  }

  state = { open: false }

  componentDidMount () {
    this.detectAdBlocker();
  }

  detectAdBlocker = async () => {
    const dummyAdContainer = this.adSampler.current;
    if (dummyAdContainer.clientHeight === 0) {  //AdBlocker is enabled
      this.setState({open: true});              //Show notification
    } else {
      try {
        //Fetch dummy data
        await this.fetchCampaignAPI();
        await this.fetchAdvertiserAPI();
      } catch (error) {
        this.setState({open: true});              //Show notification
      }
    }
  }

  fetchCampaignAPI = async () => {
    await fetch('/api/ads/campaign/', {method: 'GET'});
  }

  fetchAdvertiserAPI = async () => {
    await fetch('/api/ads/advertiser/', {method: 'GET'});
  }


  //---------------------------------------------------------------------
  //------------------------Interaction Functions------------------------
  //---------------------------------------------------------------------
  handleClose = () => {
    this.setState({open: false})
  }

  //---------------------------------------------------------------------
  //---------------------------Draw Functions----------------------------
  //---------------------------------------------------------------------
  adSampler = React.createRef();
  render() {
    const { classes, title, message, instructions, buttonLabel } = this.props;

    return (
      <div className={styles.adBlockDetector}>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={styles.notifications}>
            <Error className={styles.icon}/>
            <div className={styles.title}>{title}</div>
            <div className={styles.message}>{message}</div>
            <div className={styles.instructions}>{instructions}</div>
          </DialogContent>
          <DialogActions className={styles.controllers}>
            <Button className={classes.closeButton} variant="contained" onClick={this.handleClose} color="primary">
              {buttonLabel}
            </Button>
          </DialogActions>
        </Dialog>
        <div ref={this.adSampler}>
          <div className={`${styles.ad} ${adKeyword}`} />
        </div>
      </div>
    );
  }
}

const customStyle = {
  closeButton: {
    width: '93px',
    fontWeight: 500,
    fontSize: '14px',
    backgroundColor: '#2196F3',
    "&:hover, &:active, &:focus": {
      background: "#2196f3"
    },
  }
};
export default withStyles(customStyle)(AdBlockDetector);